import { jsx as _jsx } from "react/jsx-runtime";
import { usePOSSummary } from "@faire/retailer-visitor-shared/features/PointOfSale/hooks/usePOSSummary";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { LandingPageContext } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/LandingPageContext";
import { POSLandingPage } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/POSLandingPage";
import { trackRetailerPosGetStartedCtaClick as trackConnectClick } from "@faire/web-api--source/events/retailerPos/click/getStartedCta";
import { trackRetailerPosSignUpCtaClick as trackLoggedOutClick } from "@faire/web-api--source/events/retailerPos/click/signUpCta";
import { trackRetailerPosViewIntegrationCtaClick as trackIntegratedClick } from "@faire/web-api--source/events/retailerPos/click/viewIntegrationCta";
import { trackRetailerPosIntegratedLandingPageView as trackIntegratedView } from "@faire/web-api--source/events/retailerPos/view/integratedLandingPage";
import { trackRetailerPosLandingPageView as trackConnectView } from "@faire/web-api--source/events/retailerPos/view/landingPage";
import { trackRetailerPosLoggedOutLandingPageView as trackLoggedOutView } from "@faire/web-api--source/events/retailerPos/view/loggedOutLandingPage";
import React from "react";
export var POSAbout = function() {
    var contextValue = useContextValue();
    return /*#__PURE__*/ _jsx(LandingPageContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ _jsx(POSLandingPage, {
            isAboutPage: true
        })
    });
};
var useContextValue = function() {
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var isLinked = usePOSSummary().isLinked;
    if (!isLoggedInRetailer) {
        return {
            viewEvent: trackLoggedOutView,
            clickEvent: trackLoggedOutClick
        };
    }
    if (isLinked) {
        return {
            viewEvent: trackIntegratedView,
            clickEvent: trackIntegratedClick
        };
    }
    return {
        viewEvent: trackConnectView,
        clickEvent: trackConnectClick
    };
};
